"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m17.893 12.54-.744-1.852V10.1c0-3.166-1.496-6.347-5.174-6.35S6.804 6.934 6.804 10.1v.588l-.709 1.852a26 26 0 0 0-.55 1.555c-.703 2.258-.476 3.19-.294 3.21.353.059 1.432-1.705 1.432-1.705a4.52 4.52 0 0 0 1.646 3.281 4.6 4.6 0 0 0-1.267.573c-.294.221-.263.444-.206.535.235.395 4.042.253 5.142.132 1.097.123 4.906.268 5.142-.132.053-.091.091-.315-.209-.535a4.6 4.6 0 0 0-1.267-.573 4.52 4.52 0 0 0 1.641-3.281s1.073 1.746 1.449 1.699c.173-.02.4-.952-.294-3.21l-.568-1.549z"
}), 'Qq');
